import { FHIR_Binary_CategoryOptions_ToLabelsMap } from './types/Binary/consts.js';
import { FHIR_Condition_CategoryOptions_ToLabelsMap } from './types/Condition/consts.js';
import { FHIR_DocumentReference_CategoryOptions_ToLabelsMap, FHIR_DocumentReference_DocStatusOptions_ToLabelsMap, FHIR_DocumentReference_TypeOptions_ToLabelsMap } from './types/DocumentReference/consts.js';
import { FHIR_MedicationRequest_CategoryOptions_ToLabelsMap, FHIR_MedicationRequest_StatusOptions_ToLabelsMap } from './types/MedicationRequest/consts.js';
import { FHIR_Observation_CategoryOptions_ToLabelsMap, FHIR_Observation_CodeOptions_ToLabelsMap } from './types/Observation/consts.js';
import { FHIR_Procedure_CategoryOptions_ToLabelsMap } from './types/Procedure/consts.js';
import { FHIR_List_CodeOptions_ToLabelsMap } from './types/List/consts.js';
export const FHIR_ResourceToCategoryLabelMap = {
    AllergyIntolerance: undefined,
    Binary: FHIR_Binary_CategoryOptions_ToLabelsMap,
    Condition: FHIR_Condition_CategoryOptions_ToLabelsMap,
    DocumentReference: FHIR_DocumentReference_CategoryOptions_ToLabelsMap,
    FamilyMemberHistory: undefined,
    Immunization: undefined,
    List: undefined,
    MedicationRequest: FHIR_MedicationRequest_CategoryOptions_ToLabelsMap,
    Observation: FHIR_Observation_CategoryOptions_ToLabelsMap,
    Procedure: FHIR_Procedure_CategoryOptions_ToLabelsMap,
};
export const FHIR_ResourceToCodeOptionsLabelMap = {
    AllergyIntolerance: undefined,
    Binary: undefined,
    Condition: undefined,
    DocumentReference: undefined,
    FamilyMemberHistory: undefined,
    Immunization: undefined,
    List: FHIR_List_CodeOptions_ToLabelsMap,
    MedicationRequest: undefined,
    Observation: FHIR_Observation_CodeOptions_ToLabelsMap,
    Procedure: undefined,
};
export const FHIR_ResourceToStatusOptionsLabelMap = {
    AllergyIntolerance: undefined,
    Binary: undefined,
    Condition: undefined,
    DocumentReference: undefined,
    FamilyMemberHistory: undefined,
    Immunization: undefined,
    List: undefined,
    MedicationRequest: FHIR_MedicationRequest_StatusOptions_ToLabelsMap,
    Observation: undefined,
    Procedure: undefined,
};
export const FHIR_ResourceToDocStatusOptionsLabelMap = {
    AllergyIntolerance: undefined,
    Binary: undefined,
    Condition: undefined,
    DocumentReference: FHIR_DocumentReference_DocStatusOptions_ToLabelsMap,
    FamilyMemberHistory: undefined,
    Immunization: undefined,
    List: undefined,
    MedicationRequest: undefined,
    Observation: undefined,
    Procedure: undefined,
};
export const FHIR_ResourceToTypeOptionsLabelMap = {
    AllergyIntolerance: undefined,
    Binary: undefined,
    Condition: undefined,
    DocumentReference: FHIR_DocumentReference_TypeOptions_ToLabelsMap,
    FamilyMemberHistory: undefined,
    Immunization: undefined,
    List: undefined,
    MedicationRequest: undefined,
    Observation: undefined,
    Procedure: undefined,
};
export const FHIR_ResourceToParamOptionsLabelMaps_Map = {
    category: FHIR_ResourceToCategoryLabelMap,
    code: FHIR_ResourceToCodeOptionsLabelMap,
    docstatus: FHIR_ResourceToDocStatusOptionsLabelMap,
    status: FHIR_ResourceToStatusOptionsLabelMap,
    type: FHIR_ResourceToTypeOptionsLabelMap,
};
export const getFhirParamsLabelsMap = (_pairKey, resourceType) => {
    if (!resourceType || !_pairKey)
        return;
    return FHIR_ResourceToParamOptionsLabelMaps_Map[_pairKey]?.[resourceType];
};
//# sourceMappingURL=consts.js.map